"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelStatusRuleInactivityUnits = void 0;
var ChannelStatusRuleInactivityUnits;
(function (ChannelStatusRuleInactivityUnits) {
    ChannelStatusRuleInactivityUnits["Minutes"] = "Minutes";
    ChannelStatusRuleInactivityUnits["Hours"] = "Hours";
    ChannelStatusRuleInactivityUnits["Days"] = "Days";
})(ChannelStatusRuleInactivityUnits = exports.ChannelStatusRuleInactivityUnits || (exports.ChannelStatusRuleInactivityUnits = {}));
//# sourceMappingURL=IChannelStatusChangeRuleOptions.js.map